// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"971523a3","526":"30b3aedd","649":"dfe47735","911":"902f3cfd","949":"2d6e3d1e"}[chunkId] + ".chunk.css";
};